module.exports = __webpack_public_path__ + "fonts/nunito-sans-v11-latin-regular.619a5fef.ttf";